<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <br />
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column type="index" width="40" align="center"> </el-table-column>
            <el-table-column prop="paySn" label="支付编号" align="center" width="280">
            </el-table-column>
            <el-table-column prop="title" label="支付金额" min-width="150">
              <template slot-scope="scope">
                <h3>{{ scope.row.payAmount }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="createTime" align="center" label="支付时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>
            
          </el-table>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="total"
          @current-change="pageChange"
          @prev-click="pagePrev"
          @next-click="pageNext"
          style="float: right"
        >
        </el-pagination>
      </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import authorApi from "@/api/author";

export default {
  components: { PageHeader },
  data() {
    return {
      headLinks: [{ path: "", title: "支付记录" }],
      curPage: 1,
      tableData: [],
      total: 0,
      pageSize:10,
    };
  },
  mounted() {
    this.loadData();
  },

  methods: {
    //加载数据
    loadData() {
      authorApi.myPayList(this.curPage,this.pageSize).then((res) => {
        this.total = res.total;
        this.tableData = res.rows;
      });
    },

    pageChange(current) {
      this.curPage = current;
      this.loadData();
    },
    pagePrev(current) {
      this.curPage = current;
    },
    pageNext(current) {
      this.curPage = current;
    },
  },
};
</script>

<style lang="scss" scoped></style>
